import { render, staticRenderFns } from "./MarkdownIframe.vue?vue&type=template&id=4e224b32&scoped=true"
import script from "./MarkdownIframe.vue?vue&type=script&lang=js"
export * from "./MarkdownIframe.vue?vue&type=script&lang=js"
import style0 from "./MarkdownIframe.vue?vue&type=style&index=0&id=4e224b32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e224b32",
  null
  
)

export default component.exports